/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Tooltip,
  Modal,
  Label,
} from "react-bootstrap";
import {
  getMedication,
  deleteMedication,
  getMedicationcategory,
  is_featured_status_change,
  getCity,
  searchMedication,
  updateMedicationStatus,
  AddMedicationbulkfile,
  exportmedicationfile,
  outofstockorder,
  restockorder,
  updateMedication_old_data,
  moveToExpiryMedicine,
  GetPredictUrl,
  getAllStores,
  allocationValuePopUp,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import Datetime from "react-datetime";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import Switch from "react-bootstrap-switch";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import moment from "moment/moment";
import ReactToPrint from "react-to-print";
import BarcodeInput from "../PoList/barcode";
import RefillOrderModal from "../order/refillOrderModal";
import { CreateNewPurchaseRequest } from "api/purchaseRequest/purchaseRequest";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

export const CheckBox = (props) => {
  return (
    <li>
      <input
        key={props.id}
        onClick={props.handleCheckChieldElement}
        type="checkbox"
        checked={props.isChecked}
        value={props.value}
      />{" "}
      {props.value}
    </li>
  );
};

class viewMedication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allocatedData: [],
      showAllocatedValue: false,
      medication_detail: [],
      medication_category_detail: [],
      category: [],
      category_name: "",
      itemcode: "",
      title: "",
      medicationcategory: "",
      price: "",
      //commision: "",
      unitprice: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      tabledata: [],
      selected_id: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      medicationfile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      is_flash_medicine: "",
      is_featured: "",
      is_available: "",
      generic_name: "",
      barcode: "",
      city_info: [],
      out_of_stock_Modal: false,
      out_of_stock_state: "",
      medi_chk: [],
      statusSelected: null,
      test: [],
      re_stock_model: false,
      showExpiryMedicineModal: false,
      re_stock_state: "",
      MedicationData: [],
      expiryQuantity: "",
      availableQuantity: "",
      expiaryMedicationId: "",
      quantityError: null,
      expiryDate: "",
      userId: 0,
      expryDateError: null,
      // analytics_url: `${process.env.REACT_APP_PREDICT_ANALYTICS_API}`,
      Predict_url: "",
      viewSupplierDetails: false,
      suppliersData: [],
      store: {},
      selectedStore: "Colombo",
      selectedBarcode: "",
      showRefillRequestModal: false,
      selectedMedicationId: null,
      refillQuantityInput: "",
      refillRemarksInput: "",
      refillQuantityError: null,
      refillRemarksError: null,
      isRefillSubmitting: false,
    };
    this.isRefillSubmitting = false;
    this.componentRef = React.createRef();
    this.fileInput = React.createRef();
    this.submitbulkmedication = this.submitbulkmedication.bind(this);
    this.selectedmedication = this.selectedmedication.bind(this);
    this.deletemedicaton = this.deletemedicaton.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.handleOutOfStock = this.handleOutOfStock.bind(this);
    this.addbulkmedication = this.addbulkmedication.bind(this);
    this.warningWithConfirmAndCancelStatusMessage.bind(this);
    this.chargemedication = this.chargemedication.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedmedication(cus) {
    // console.log(cus);
    localStorage.setItem("medicationID", JSON.stringify(cus));

    this.props.history.push("/admin/edit_medication");
  }
  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });

    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await getMedicationcategory(obj, pg_no, 100)
        .then((res) => {
          const cat_data = res.data;
          if (cat_data.data.length == 0) {
            compelte = 0;
          } else {
            var array1 = this.state.category;
            var array2 = array1.concat(cat_data.data);
            this.setState({
              category: array2,
              category_name: cat_data.category_name,
            });
          }
        })
        .catch((error) => {
          compelte = 0;
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
      pg_no++;
    }
    var country_id = "1";
    getCity(obj, country_id)
      .then((res) => {
        this.setState({ city_info: res.data });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });

    await getAllStores().then((stores) => {
      const storesData = stores.data;
      this.setState({
        store: storesData,
      });
    });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication</b> - moved to expiry list Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    this.searchdata();
  };

  // storesSelect = async () => {
  //   const stores = await getAllStores();
  // };

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  submitCancelOrderModal() {
    let error = false;

    if (!error) {
      this.setState({ isLoading: true });
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let status_chnage = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          status_chnage.push({
            id: item.id,
            status: this.state.statusSelected,
          });
        }
      });
      updateMedicationStatus(status_chnage, obj)
        .then((res) => {
          this.searchData();
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          console.log("error");
        });
      this.setState({
        selected_id: [],
        statusSelected: "",
      });
    }
  }

  closeCancelOrderModal() {
    this.setState({
      selected_id: [],
      statusSelected: "",
    });
    this.searchData();
  }

  handleOutOfStock = (e) => {
    console.log(this.state.test);
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let sts_arr = [];

    if (this.state.statusSelected != "" && this.state.statusSelected != null) {
      this.state.medi_chk.map((item) => {
        if (item.isChecked) {
          this.state.selected_id.push({ item_code: item.item_code });
          sts_arr.push({
            item_code: item.item_code,
            status: this.state.statusSelected,
          });
        }
      });

      if (this.state.statusSelected != 1) {
        if (this.state.selected_id.length > 0) {
          this.setState({
            alert: (
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="Please select order!"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              />
            ),
          });
        }
      }
      if (this.state.bulkSelect != "0") {
        if (sts_arr.length > 0) {
          this.setState({ isLoading: true });
          updateMedicationStatus(sts_arr, obj).then(() => {
            this.searchData();
            this.setState({ selected_id: [] });
          });
        } else {
          this.setState({
            alert: (
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="Please select order!"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              />
            ),
          });
        }
      }
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Please select status!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          />
        ),
      });
    }
  };

  resetSearch(e) {
    this.setState({
      itemcode: "",
      title: "",
      medicationcategory: "",
      price: "",
      //commision: "",
      unitprice: "",
      city: "0",
      is_flash_medicine: "",
      is_featured: "",
      is_available: "",
      generic_name: "",
      barcode: "",
      store: "",
    });
    this.searchData();
  }
  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchMedication(
        this.state.itemcode,
        this.state.title,
        this.state.price,
        this.state.medicationcategory,
        //this.state.commision,
        this.state.unitprice,
        this.state.city,
        this.state.is_flash_medicine,
        this.state.page,
        this.state.is_featured,
        this.state.is_available,
        this.state.generic_name,
        this.state.barcode,
        // this.state.store,
        obj,
      )
        .then((response1) => {
          var data = response1.data;
          var medication_category = data.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          // console.log(data.next_page_url);
          // console.log(data,data.last_page);
          var $no_pages = [];
          let medi_chk = [];
          let serach_string = "";

          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            } else {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            } else {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });

          response1.data.data.map((ele) => {
            ele["isChecked"] = false;
            medi_chk.push(ele);
          });
          this.setState({
            order_details: response1.data,
            loading: false,
          });
          this.setState({
            medi_chk: medi_chk,
          });
          this.setState({ isLoading: false });
          this.setState({
            loading: false,
            tabledata: data.data,
            medication_category_detail: medication_category,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletemedicaton(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Medication Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  addbulkmedication() {
    this.setState({
      showbulkui: 1,
    });
  }
  closemedicatonupload() {
    this.setState({
      showbulkui: 0,
    });
  }

  exportfile() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    exportmedicationfile(obj).then((res) => {});
  }

  is_feature_change(id, feature) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var is_featured = "";
    if (feature == "1") {
      is_featured = 0;
    } else if (feature == "0") {
      is_featured = 1;
    }
    is_featured_status_change(is_featured, id, obj).then((res) => {
      if (res.data.success == true) {
        this.searchData();
      }
    });
  }

  markmedoutofstock(id) {
    this.setState({ out_of_stock_Modal: true, out_of_stock_state: id });
  }

  markmedrestock(id) {
    this.setState({ re_stock_model: true, re_stock_state: id });
  }

  handleInputChange(event) {
    // let file = event.target.files[0]
    // console.log(file)
    // this.setState({ medicationfile: event.target.files[0] });
    // this.setState({
    //   medicationfile: file
    //   })
  }
  submitbulkmedication() {
    // var token = JSON.parse(localStorage.getItem('user'));
    // const  obj = token.token
    // const file_data = this.state.medicationfile;
    // console.log(file_data,'file data')
    // const data = new FormData();
    // data.append('myFile',file_data)
    // // alert(`selected file - ${this.fileInput.current.files[0]}`)
    // // console.log(formdata)
    // AddMedicationbulkfile(data,obj)
    // .then((res)=>{
    //     alert(res);
    // })
    // .then(error => {
    //   console.log(error)
    // })
  }
  handleAllocatedValuePop(id) {
    this.setState({ showAllocatedValue: true });
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    allocationValuePopUp(id, obj)
      .then((res) => {
        const data = res.data;
        this.setState({ allocatedData: data });
      })
      .catch((error) => {
        console.error("Error fetching allocated data:", error);
      });
  }

  deletemedicaton(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    deleteMedication(id, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/medication-category";
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  addmedication() {
    this.props.history.push("/admin/addmedication");
  }

  handleAllChecked = (event) => {
    let medication_st = this.state.medi_chk;

    medication_st.forEach((st) => (st.isChecked = event.target.checked));
    this.setState({ medi_chk: medication_st });
    // console.log(medication_st);
  };

  handleCheckChieldElement = (event) => {
    let medication_st = this.state.medi_chk;

    medication_st.forEach((st) => {
      if (st.id == event.target.value) {
        st.isChecked = event.target.checked;
        this.setState({
          test: [
            ...this.state.test,
            st.isChecked === event.target.checked ? st : "",
          ],
        });
      }
    });
  };

  onStatusChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;

    if (value == 0) {
      this.warningWithConfirmAndCancelStatusMessage(value);
    }
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  warningWithConfirmAndCancelStatusMessage(id) {
    console.log(id, "<<<--- id");
    console.log(this.state);
    let order_id = [];

    this.state.medi_chk.map((item) => {
      if (item.isChecked) {
        order_id.push(item.id);
      }
    });

    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.chargemedication(order_id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Confirm"
          cancelBtnText="Cancel"
          showCancel
        >
          Please note that the customer will be charged are you sure ?
        </SweetAlert>
      ),
    });
  }

  chargemedication(data) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      isLoading: true,
    });
  }

  close_out_of_stock_Modal() {
    this.setState({
      out_of_stock_Modal: false,
      Cancel_reason_state: "",
    });
  }

  outofstock() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    outofstockorder(this.state.out_of_stock_state, obj)
      .then((response) => {
        this.searchData();
        console.log(response);
      })
      .catch((err) => console.log(err));
    this.setState({
      out_of_stock_Modal: false,
      Cancel_reason_state: "",
    });
  }

  close_re_stock_Modal() {
    this.setState({
      re_stock_model: false,
      Cancel_reason_state: "",
    });
  }

  restock() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    restockorder(this.state.re_stock_state, obj)
      .then((response) => {
        this.searchData();
        console.log(response);
      })
      .catch((err) => console.log(err));
    this.setState({
      re_stock_model: false,
      Cancel_reason_state: "",
    });
  }

  openExpiryModal(medicationId) {
    this.setState({ showExpiryMedicineModal: true });

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const userId = token.id;

    updateMedication_old_data(medicationId, obj)
      .then((res) => {
        this.setState({
          MedicationData: res.data,
          availableQuantity: res.data.total_quantity,
          expiaryMedicationId: res.data.id,
          userId: userId,
        });
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });

    // console.log('medicationId', medicationId)
  }

  handleAvailablrOnChange(event) {
    const value = event.target.value;
    const availableQuantity =
      Number(this.state.MedicationData.total_quantity) -
      Number(event.target.value);
    this.setState({
      expiryQuantity: value,
      availableQuantity: availableQuantity,
    });

    if (event.target.value === "") {
      this.setState({
        quantityError: (
          <small className="text-danger">quantity is required.</small>
        ),
      });
    } else if (
      Number(event.target.value) >
      Number(this.state.MedicationData.total_quantity)
    ) {
      this.setState({
        quantityError: (
          <small className="text-danger">
            quantity should less than available quantity.
          </small>
        ),
      });
    } else {
      this.setState({ quantityError: null });
    }
  }

  handleModalClose() {
    this.setState({
      showExpiryMedicineModal: false,
      expiryDate: "",
      expiryQuantity: "",
    });
  }
  handleExpiryModalSubmit() {
    if (this.state.expiryQuantity === "") {
      this.setState({
        quantityError: (
          <small className="text-danger">quantity is required.</small>
        ),
      });
    } else if (
      Number(this.state.expiryQuantity) >
      Number(this.state.MedicationData.total_quantity)
    ) {
      this.setState({
        quantityError: (
          <small className="text-danger">
            quantity should less than available quantity.
          </small>
        ),
      });
    } else if (this.state.expiryDate === "") {
      this.setState({
        expryDateError: (
          <small className="text-danger">Expiry date is required.</small>
        ),
      });
    } else {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      moveToExpiryMedicine(
        this.state.expiaryMedicationId,
        this.state.expiryDate,
        this.state.expiryQuantity,
        this.state.userId,
        obj,
      )
        .then((response) => {
          if (response.success === true) {
            this.setState({
              showExpiryMedicineModal: false,
              expiryQuantity: "",
              expiryDate: "",
            });
            this.handleSuccess("bl");
            this.searchData();
          } else {
            var color = Math.floor(Math.random() * 4 + 1);
            var level;
            switch (color) {
              case 1:
                level = "success";
                break;
              case 2:
                level = "warning";
                break;
              case 3:
                level = "error";
                break;
              case 4:
                level = "info";
                break;
              default:
                break;
            }
            level = "error";
            this.state._notificationSystem.addNotification({
              title: <span data-notify="icon" className="pe-7s-gift"></span>,
              message: (
                <div>
                  <b>{response.message}</b>.
                </div>
              ),
              level: level,
              position: "bl",
              autoDismiss: 15,
            });
          }
        })
        .catch((err) => console.log(err));
    }
  }
  disablePastDt = (current) => {
    const yesterday = moment().subtract(1, "day");
    return current.isAfter(yesterday);
  };

  // getPredictUrlValue = (medicationId) => {
  //   var token = JSON.parse(localStorage.getItem("user"));
  //   // console.log(token.token);
  //   const obj = token.token;
  //   // console.log("medicationId" , medicationId)
  //   GetPredictUrl(medicationId)
  //     .then((res) => {
  //       if (!res.data.error) {
  //         this.setState({ Predict_url: res.data.path });
  //         window.open(`${this.state.analytics_url}${res.data.path}`);
  //       } else {
  //         this.setState({
  //           alert: (
  //             <SweetAlert
  //               style={{ display: "block", marginTop: "-100px" }}
  //               title={`${res.data.msg}`}
  //               onConfirm={() => this.hideAlert()}
  //               onCancel={() => this.hideAlert()}
  //               confirmBtnBsStyle="info"
  //             />
  //           ),
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error, "== error");
  //       this.handleNetworkError("bl", error);
  //     });
  // };
  ViewSupplierList(id) {
    this.state.viewSupplierDetails = true;
    const suppliersData = this.state.tabledata.find((data) => {
      if (data.id === id) {
        this.setState({ suppliersData: data.suppliers_data });
      }
    });
  }
  handlePrint = (itemcode) => {
    this.componentRef.current.handlePrint(itemcode);
  };

  getPharmacyQuantity = (storeMedicine, type) => {
    if (!Array.isArray(storeMedicine)) {
      return 0;
    }

    if (type === "pharmacy") {
      const store = storeMedicine.find(
        (s) => s.pharmacies && s.pharmacies.name === "Flash Health Pharmacy",
      );
      return store ? store.quantity : 0;
    }
    if (type === "store") {
      const store = storeMedicine.find(
        (s) => s.pharmacies && s.pharmacies.name === "Flash WareHouse",
      );
      return store ? store.quantity : 0;
    }
    return 0;
  };

  showRefillRequestModal = (cus) => {
    this.setState({ showRefillRequestModal: true, selectedMedicationId: cus });
  };

  handleRefillQuantityChange = (index, event) => {
    const value = event.target.value;
    this.setState({ refillQuantityInput: value, refillQuantityError: null });
  };

  handleRefillRemarksChange = (index, event) => {
    const value = event.target.value;
    this.setState({ refillRemarksInput: value, refillRemarksError: null });
  };

  handleRefillRequestSubmit = async (index) => {
    if (this.isRefillSubmitting) {
      return;
    }

    let error = false;

    if (
      !this.state.refillQuantityInput ||
      this.state.refillQuantityInput == "" ||
      Number(this.state.refillQuantityInput) <= 0
    ) {
      error = true;
      this.setState({
        refillQuantityError: (
          <small className="text-danger">
            Please enter a valid refill quantity.
          </small>
        ),
      });
    }
    console.log(
      "this.state.refillQuantityInput",
      this.state.refillQuantityInput,
    );

    if (
      Number(this.state.refillQuantityInput) >
        Number(
          this.getPharmacyQuantity(
            this.state.selectedMedicationId.store_wise_medication,
            "pharmacy",
          ),
        ) &&
      (this.state.refillRemarksInput == "" || !this.state.refillRemarksInput)
    ) {
      error = true;
      this.setState({
        refillRemarksError: (
          <small className="text-danger">
            Please enter remarks for the refill request.
          </small>
        ),
      });
    }

    if (error) {
      return;
    }

    if (!error) {
      this.isRefillSubmitting = true;
      this.setState({ isRefillSubmitting: true });

      try {
        await this.callRequestRefillAPI(
          this.state.selectedMedicationId,
          index,
          this.state.refillQuantityInput,
          this.state.refillRemarksInput,
        );
      } catch (error) {
        this.handleNetworkError("bl", error);
      } finally {
        this.isRefillSubmitting = false;
        this.setState({ isRefillSubmitting: false });
      }
    }
  };

  callRequestRefillAPI = async (
    selectedMedicationId,
    index,
    customQuantity,
    customRemarks,
  ) => {
    if (!selectedMedicationId == null) {
      console.warn("Refill request skipped: item not found");
      return;
    }

    const medicationId = selectedMedicationId.id;

    if (!medicationId) {
      console.warn(
        "Refill request skipped: medication id missing",
        selectedMedicationId.id,
      );
      return;
    }
    let refillQuantity = Number(customQuantity || 0);

    if (!refillQuantity || refillQuantity <= 0) {
      refillQuantity = 0;
    }

    if (
      refillQuantity === 0 &&
      Number(
        this.getPharmacyQuantity(
          selectedMedicationId.store_wise_medication,
          "pharmacy",
        ),
      ) < Number(selectedMedicationId.reorder_level)
    ) {
      refillQuantity =
        Number(selectedMedicationId.reorder_level) -
        Number(
          this.getPharmacyQuantity(
            selectedMedicationId.store_wise_medication,
            "pharmacy",
          ),
        ) +
        Number(selectedMedicationId.daily_consumption);
    }

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const payload = {
      reference: "",
      request_date: new Date().toISOString(),
      status: 1,
      request_by: token.id,
      order_id: this.props.match.params.id,
      remark: customRemarks ? customRemarks : "",
      medications: [
        {
          id: medicationId,
          quantity: refillQuantity,
        },
      ],
      store_id: 10,
    };
    const createPurchaseRequests = await CreateNewPurchaseRequest(obj, payload);
    if (createPurchaseRequests.data.success) {
      this.setState({
        showRefillRequestModal: false,
        refillQuantityInput: "",
        refillRemarksInput: "",
      });
    }
  };

  render() {
    const { cus } = this.props;
    const change_status = (
      <Tooltip id="change_status">Change Feature Status</Tooltip>
    );
    const barcodenotification = (
      <Tooltip id="barcodenotification">Generate Barcode</Tooltip>
    );
    const mark_outofstock = (
      <Tooltip id="mark_outofstock">Mark sold out in app</Tooltip>
    );
    const mark_restock = <Tooltip id="mark_restock">Enable in app</Tooltip>;
    const markAsExpiryMedicine = (
      <Tooltip id="markAsExpiryMedicine">Mark as expiry medicine</Tooltip>
    );
    const viewSupplierDetails = (
      <Tooltip id="viewSupplierDetails">View Supplier Details</Tooltip>
    );
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const refillRequest = <Tooltip id="refillRequest">Request Refill</Tooltip>;
    const selected_id = this.state.selected_id;
    const medication = this.state.tabledata;
    const order_data = this.state.medi_chk;
    // const Analytics_url = this.state.analytics_url;

    const category = this.state.category;
    const city_info = this.state.city_info;
    const { store, selectedStore } = this.state;
    // console.log(selected_id);
    // const medication_category_detail =  medication.map(med=>{
    //   med.medication_category.map(cat=>{
    //    <td> {cat.category_name}</td>
    //   })
    // })
    // console.log(medication_category_detail)
    var c = 1;
    // console.log(medication);
    // const medicationcat = category.map((cat)=>{
    //   {cat.id}
    //   // ':' ;{cat.catgory_name}
    // })
    const add_Commisson_array = { 1: "Yes", 0: "No" };
    return (
      <>
        <div className="main-content">
          <Grid fluid>
            {this.state.alert}
            <NotificationSystem ref="notificationSystem" style={style} />
            <Row>
              <Col md={12}>
                <Card
                  tableFullWidth
                  content={
                    <Row>
                      {/* {this.state.useraccess == 8 ? ( */}
                      {/* "" */}
                      {/* ) : ( */}
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          <Button
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150 "
                            class="btn-color" //bsStyle="info" fill
                            onClick={this.addmedication.bind(this)}
                          >
                            Add Medication <i className="fa fa-plus"></i>
                          </Button>
                          <br />
                          &nbsp;
                          {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkmedication.bind(this)}  bsStyle="info" fill  >Add Bulk Medication</Button> */}
                        </Col>

                        {/* {this.state.showbulkui == 1 ?
          <Col xs={12} sm={12} md={12} lg={12} >
          <h5>Upload Medication details</h5>
          <form>
            <FormGroup>
            <ControlLabel>Bulk Medication</ControlLabel>
            <input type="file"  name="medicationfile" onChange={this.handleInputChange}  placeholder="select file" />
            </FormGroup>
            <FormGroup>
              <Button fill onClick={this.submitbulkmedication.bind(this)} bsStyle="success">Submit</Button>
              &nbsp;
              <Button fill  onClick={this.closemedicatonupload.bind(this)} bsStyle="danger">close</Button>
              &nbsp;
              <Button fill  onClick={this.exportfile.bind(this)} bsStyle="danger">export</Button>
              
            </FormGroup>
          </form>
          </Col>
          : ''} */}
                      </Col>
                      {/* )} */}
                      <br />
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          md={3}
                          sm={4}
                          lg={3}
                          xs={12}
                          className="fl_status_dropdown"
                        >
                          <select
                            onChange={this.onStatusChange}
                            name="statusSelected"
                            value={this.state.statusSelected}
                            className="form-control"
                          >
                            <option value="">Select</option>
                            <option value="1">Out Of Stock</option>
                          </select>
                        </Col>

                        <Col md={3} sm={4} lg={3} xs={12}>
                          <Button
                            className="fl_btn_change_order_status btn-fill"
                            class="btn-color"
                            fill
                            onClick={this.handleOutOfStock.bind(this)}
                          >
                            Change
                          </Button>
                        </Col>
                      </Col>
                      <br />
                      &nbsp;
                      <Col
                        className="OrderList_fill"
                        style={{
                          borderRadius: "5px",
                          padding: "10px 20px",
                          width: "97%",
                          margin: "0px auto",
                        }}
                      >
                        <Row>
                          <Col sm={3} xs={12}>
                            <FormControl
                              name="itemcode"
                              value={this.state.itemcode || ""}
                              placeholder="Item Code"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>
                          <Col sm={3} xs={12}>
                            <FormControl
                              name="generic_name"
                              value={this.state.generic_name || ""}
                              placeholder="Generic Name"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>

                          <Col sm={3} xs={12}>
                            <FormControl
                              name="title"
                              value={this.state.title || ""}
                              placeholder="Title"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>
                          <Col sm={3} xs={12}>
                            <FormControl
                              name="barcode"
                              value={this.state.barcode || ""}
                              placeholder="Barcode"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>
                          <Col sm={3} xs={12}>
                            {/* <select
              className="form-control"
              style={{ margin: "0.4rem" }}
              name="medicationcategory"
              value={this.state.medicationcategory || ""}
              onChange={this.onChange}
              type="select"
            >
              <option value="">Select Medication Category</option>
              {category.map((cat) => (
                <option value={cat.id}>
                  {cat.category_name}
                </option>
              ))}
            </select> */}
                            {/* <FormControl  name="medicationcategory" value={this.state.medicationcategory ||''} placeholder="Medicationcategory" onChange={this.onChange} type="text" /> */}
                          </Col>
                          {/* <Col md={1} sm={1} lg={1}  xs={12} className="fl_mb_1 w_150">
      <FormControl name="price" value={this.state.price ||''} placeholder="Price" onChange={this.onChange} type="text" />
      </Col> */}
                          {/*<Col
                md={1}
                sm={1}
                lg={1}
                xs={12}
                className="fl_mb_1 w_150"
                style={{ width: "13%", marginTop: "5px" }}
              >
                <select
                  name="commision"
                  placeholder="Commision"
                  value={this.state.commision || ""}
                  onChange={this.onChange}
                  className="form-control"
                >
                  <option value="">Commission</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </Col>*/}
                        </Row>
                        <Row>
                          <Col sm={3} xs={12}>
                            <FormControl
                              name="unitprice"
                              value={this.state.unitprice || ""}
                              placeholder="Unit Price"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>
                          <Col sm={3} xs={12}>
                            <select
                              name="is_available"
                              placeholder="is_available"
                              style={{ margin: "0.4rem" }}
                              value={this.state.is_available || ""}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="">Is available ?</option>
                              <option value="1">available</option>
                              <option value="0">Unavailable</option>
                            </select>
                          </Col>
                          <Col sm={3} xs={12}>
                            {/* <FormControl  name="commision" value={this.state.commision ||''} placeholder="Commision" onChange={this.onChange} type="text" /> */}
                            <select
                              name="is_flash_medicine"
                              placeholder="is_flash_medicine"
                              style={{ margin: "0.4rem" }}
                              value={this.state.is_flash_medicine || ""}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="">Flash Medicine</option>
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                            </select>
                          </Col>
                          <Col sm={3} xs={12}>
                            {/* <FormControl  name="commision" value={this.state.commision ||''} placeholder="Commision" onChange={this.onChange} type="text" /> */}
                            <select
                              name="is_featured"
                              placeholder="is_featured"
                              style={{ margin: "0.4rem" }}
                              value={this.state.is_featured || ""}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="">Is Featured</option>
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                            </select>
                          </Col>
                          {/* <Col sm={3} xs={12}>
              <select
                name="store"
                placeholder="Select Store"
                style={{ margin: "0.4rem" }}
                value={selectedStore}
                onChange={(e) =>
                  this.setState({ selectedStore: e.target.value })
                }
                className="form-control"
              >
                <option value="">Select Store</option>
                {Object.entries(store).map(([id, name]) => (
                  <option key={id} value={id}>
                    {name}
                  </option>
                ))}
              </select>
            </Col> */}
                          {/*<Col
              md={1}
              sm={1}
              lg={1}
              xs={12}
              className="fl_mb_1 w_150"
              style={{ width: "13%", paddingTop: "3px" }}
            >
              {/* <FormControl  name="commision" value={this.state.commision ||''} placeholder="Commision" onChange={this.onChange} type="text" /> */}
                          {/*<select name="city" placeholder="City" value={this.state.city ||''} onChange={this.onChange} className="form-control">
      <option value="0">Select City</option>
             {city_info.map((cus)=> (
            <option value={cus.id}>{cus.city_name}</option>
            ))}
             </select> }
            </Col>*/}
                        </Row>
                        <Row>
                          <Col sm={3} xs={12}>
                            <Button
                              class="btn-color" //bsStyle="info"
                              style={{ margin: "0.4rem" }}
                              fill
                              onClick={this.searchdata.bind(this)}
                            >
                              Filter
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                              class="btn-color" //bsStyle="info"
                              fill
                              style={{ margin: "0.4rem" }}
                              onClick={this.resetSearch.bind(this)}
                            >
                              Reset
                            </Button>
                          </Col>
                          <Col
                            md={1}
                            sm={1}
                            lg={1}
                            xs={12}
                            className="fl_mb_1 w_150"
                            style={{ width: "13%", paddingTop: "3px" }}
                          >
                            {/* <FormControl  name="commision" value={this.state.commision ||''} placeholder="Commision" onChange={this.onChange} type="text" /> */}
                            {/*<select name="city" placeholder="City" value={this.state.city ||''} onChange={this.onChange} className="form-control">
    <option value="0">Select City</option>
           {city_info.map((cus)=> (
          <option value={cus.id}>{cus.city_name}</option>
          ))}
           </select> */}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <div className="table-responsive medication-table-scroll">
                          <Table className="medication-table-sticky">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    onClick={this.handleAllChecked}
                                    value="checkedall"
                                  />{" "}
                                </th>
                                <th>Item Code</th>
                                <th> Medication Title</th>
                                {/* <th>Store</th> */}
                                <th>placement</th>
                                <th>Selling Price</th>
                                {/*<th>Commision (10%)</th>*/}
                                {/* <th>Available Quantity</th> */}
                                {/* <th>Total Allocated</th> */}
                                <th>Pharmacy Qty</th>
                                <th>Store Qty</th>
                                <th>Consumption Level</th>
                                <th>Reorder Level</th>
                                <th>Buying Price</th>
                                <th>Average price</th>
                                {/*<th>City</th> */}
                                <th>Feature</th>
                                <th>Margin</th>
                                {/* <th>Analytics</th> */}
                                {/* <th>Description</th> */}
                                {/* {this.state.useraccess == 3 ? ( */}
                                {/* ""
            ) : ( */}
                                <th className="text-right">Actions</th>
                                {/* )} */}
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  <div style={{ display: "none" }}>
                                    <div
                                      className="print-only"
                                      ref={this.componentRef}
                                    >
                                      <BarcodeInput
                                        name={""}
                                        itemcode={this.state.selectedBarcode}
                                      />
                                    </div>
                                  </div>
                                  {medication.map((cus) => (
                                    <tr>
                                      <td>
                                        <input
                                          key={cus.id}
                                          onChange={
                                            this.handleCheckChieldElement
                                          }
                                          type="checkbox"
                                          checked={cus.isChecked}
                                          value={cus.id}
                                        />{" "}
                                      </td>
                                      <td>{cus.item_code}</td>
                                      <td>
                                        <div className="medication-title-cell">
                                          <span>{cus.title}</span>
                                          {cus.suppliers_data &&
                                            cus.suppliers_data.length > 0 && (
                                              <OverlayTrigger
                                                key={`supplier-badge-${cus.id}`}
                                                placement="top"
                                                overlay={viewSupplierDetails}
                                              >
                                                <button
                                                  type="button"
                                                  className="supplier-details-badge"
                                                  onClick={() =>
                                                    this.ViewSupplierList(
                                                      cus.id,
                                                    )
                                                  }
                                                >
                                                  Details
                                                </button>
                                              </OverlayTrigger>
                                            )}
                                        </div>
                                      </td>
                                      {/* <td>Colombo</td> */}
                                      <td style={{ textAlign: "center" }}>
                                        {cus.ycoord}
                                        {cus.xcoord}
                                      </td>
                                      <td>{(cus.price - 0).toFixed(2)}</td>
                                      {/*<td>
                              {add_Commisson_array[cus.add_commision]}
                           </td>*/}
                                      <td>
                                        {this.getPharmacyQuantity(
                                          cus.store_wise_medication,
                                          "pharmacy",
                                        )}
                                      </td>
                                      <td>
                                        {this.getPharmacyQuantity(
                                          cus.store_wise_medication,
                                          "store",
                                        )}
                                      </td>
                                      <td>
                                        {cus.daily_consumption == null
                                          ? "0"
                                          : Math.floor(cus.daily_consumption)}
                                      </td>
                                      <td>
                                        {cus.reorder_level == null
                                          ? "0"
                                          : Math.floor(cus.reorder_level)}
                                      </td>
                                      {/* <td
                              style={{
                                paddingBottom: "2px",
                                verticalAlign: "bottom",
                                color: "#ff8a26",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.handleAllocatedValuePop(cus.id)
                              }
                            >
                              {Math.floor(cus.total_allocated)}
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#ff8a26",
                                  fontWeight: "bold",
                                  paddingTop: "3px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.handleAllocatedValuePop(cus.id)
                                }
                              >
                                Allocated:{" "}
                                {cus.total_allocated == null
                                  ? 0
                                  : Math.floor(cus.total_allocated)}
                              </div>
                            </td> */}
                                      <td>
                                        {(cus.buying_price - 0).toFixed(2)}
                                      </td>
                                      <td>{(cus.unit_price - 0).toFixed(2)}</td>
                                      <td>
                                        {cus.is_featured == "0" ? "No" : "Yes"}
                                      </td>
                                      <td>
                                        {(() => {
                                          const sellingPrice = Number(
                                            cus.price,
                                          );
                                          const unitPrice = Number(
                                            cus.unit_price,
                                          );
                                          const marginPercentages =
                                            ((sellingPrice - unitPrice) * 100) /
                                            unitPrice;
                                          const marginPercentage = isNaN(
                                            marginPercentages,
                                          )
                                            ? 0
                                            : marginPercentages;
                                          let color = "";
                                          let rangeLabel = "";
                                          if (marginPercentage < 10) {
                                            color = "red";
                                            rangeLabel = "Below 10%";
                                          } else if (
                                            marginPercentage >= 10 &&
                                            marginPercentage < 15
                                          ) {
                                            color = "orange";
                                            rangeLabel = "10-15%";
                                          } else if (
                                            marginPercentage >= 15 &&
                                            marginPercentage < 20
                                          ) {
                                            color = "green";
                                            rangeLabel = "15-20%";
                                          } else if (
                                            marginPercentage >= 20 &&
                                            marginPercentage < 25
                                          ) {
                                            color = "purple";
                                            rangeLabel = "20-25%";
                                          } else {
                                            color = "blue";
                                            rangeLabel = "Above 25%";
                                          }
                                          return (
                                            <span
                                              style={{
                                                color,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {marginPercentage.toFixed(2)}
                                              &nbsp;(
                                              {rangeLabel})
                                            </span>
                                          );
                                        })()}
                                      </td>
                                      {/* <td>
                                      <Button
                                        onClick={() =>
                                          this.getPredictUrlValue(cus.id)
                                        }
                                      >
                                        View
                                      </Button>
                                    </td> */}
                                      {
                                        // this.state.useraccess == 4 ||
                                        // this.state.useraccess == 6 ||
                                        // this.state.useraccess == 7 ||
                                        // this.state.useraccess == 8 ||
                                        // this.state.useraccess == 9 ||
                                        // this.state.useraccess == 10 ?
                                        // (
                                        //   ""
                                        // ) :
                                        <td className="td-actions text-right no-padding">
                                          <ReactToPrint
                                            trigger={() => (
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={barcodenotification}
                                              >
                                                <Button
                                                  simple
                                                  bsStyle="info"
                                                  bsSize="xs"
                                                  onClick={() =>
                                                    this.setState({
                                                      selectedBarcode:
                                                        cus.item_code,
                                                    })
                                                  }
                                                >
                                                  <i className="fa fa-barcode" />
                                                </Button>
                                              </OverlayTrigger>
                                            )}
                                            content={() =>
                                              this.componentRef.current
                                            }
                                            onBeforeGetContent={() =>
                                              new Promise((resolve) => {
                                                this.setState(
                                                  {
                                                    selectedBarcode:
                                                      cus.item_code,
                                                  },
                                                  () => {
                                                    resolve();
                                                  },
                                                );
                                              })
                                            }
                                          />

                                          <OverlayTrigger
                                            placement="top"
                                            overlay={markAsExpiryMedicine}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={() =>
                                                this.openExpiryModal(cus.id)
                                              }
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-plus" />
                                            </Button>
                                          </OverlayTrigger>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={mark_outofstock}
                                          >
                                            {cus.is_out_of_stock == 1 ? (
                                              <Button
                                                disabled
                                                simple
                                                bsStyle="danger"
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-exclamation-triangle" />
                                              </Button>
                                            ) : (
                                              <Button
                                                simple
                                                bsStyle="danger"
                                                onClick={this.markmedoutofstock.bind(
                                                  this,
                                                  cus.id,
                                                  cus.is_featured,
                                                )}
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-exclamation-triangle" />
                                              </Button>
                                            )}
                                          </OverlayTrigger>

                                          <OverlayTrigger
                                            placement="top"
                                            overlay={mark_restock}
                                          >
                                            {cus.is_out_of_stock == 0 ? (
                                              <Button
                                                disabled
                                                simple
                                                bsStyle="secondary"
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-exclamation-triangle" />
                                              </Button>
                                            ) : (
                                              <Button
                                                simple
                                                bsStyle="info"
                                                onClick={this.markmedrestock.bind(
                                                  this,
                                                  cus.id,
                                                  cus.is_featured,
                                                )}
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-exclamation-triangle" />
                                              </Button>
                                            )}
                                          </OverlayTrigger>

                                          <OverlayTrigger
                                            placement="top"
                                            overlay={change_status}
                                          >
                                            <Button
                                              simple
                                              bsStyle="info"
                                              onClick={this.is_feature_change.bind(
                                                this,
                                                cus.id,
                                                cus.is_featured,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-check-square-o" />
                                            </Button>
                                          </OverlayTrigger>
                                          {/* {this.state.useraccess === 1 || */}
                                          {/* this.state.useraccess === 11 ? ( */}
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={edit}
                                          >
                                            <Button
                                              simple
                                              bsStyle="success"
                                              onClick={this.selectedmedication.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-edit" />
                                            </Button>
                                          </OverlayTrigger>
                                          {/* ) : ( */}
                                          {/* "" */}
                                          {/* )} */}
                                          {/* {this.state.useraccess == 1 && ( */}
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={remove}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={this.warningWithConfirmAndCancelMessage.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-times" />
                                            </Button>
                                          </OverlayTrigger>
                                          <OverlayTrigger
                                            key={cus.id}
                                            placement="top"
                                            overlay={refillRequest}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={() =>
                                                this.showRefillRequestModal(cus)
                                              }
                                              bsSize="xs"
                                            >
                                              <li className="fa fa-file-text"></li>
                                            </Button>
                                          </OverlayTrigger>
                                          {/* )} */}
                                        </td>
                                      }
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        {this.state.loading ? (
                          ""
                        ) : this.state.noRecordFound ? (
                          ""
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Pagination>
                              <Pagination.First
                                dataUrl={this.state.prevpage}
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.prevpage,
                                )}
                                disabled={this.state.prevdisabled}
                              />
                              {this.state.paginationData.map((url) => (
                                <Pagination.Item
                                  dataUrl={url}
                                  active={
                                    this.state.currentPage == c ? "1" : null
                                  }
                                  onClick={this.paginationinfo.bind(this, url)}
                                >
                                  {c++}
                                </Pagination.Item>
                              ))}
                              <Pagination.Last
                                dataUrl={this.state.nextpage}
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.nextpage,
                                )}
                                disabled={this.state.nextdisabled}
                              />
                            </Pagination>
                          </div>
                        )}

                        <Modal
                          show={this.state.viewSupplierDetails}
                          onHide={() =>
                            this.setState({ viewSupplierDetails: false })
                          }
                          bsSize="lg"
                        >
                          <Modal.Header>
                            <Modal.Title>View Supplier Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body style={{ overflowY: "scroll" }}>
                            <Table>
                              <thead>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile No</th>
                              </thead>
                              <tbody>
                                {this.state.suppliersData.length == 0 ? (
                                  <td
                                    colspan="10"
                                    style={{ textAlign: "center" }}
                                  >
                                    <h5>No Data Found</h5>{" "}
                                  </td>
                                ) : (
                                  this.state.suppliersData.map((item) => (
                                    <tr>
                                      <td>{item.name}</td>
                                      <td>{item.email}</td>
                                      <td>{item.mobile}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </Table>
                          </Modal.Body>
                          <Modal.Footer>
                            <Col sm={12} md={12} xs={12} className="text-right">
                              <Button
                                bsStyle="danger"
                                fill
                                onClick={() =>
                                  this.setState({ viewSupplierDetails: false })
                                }
                              >
                                Cancel
                              </Button>
                            </Col>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.showExpiryMedicineModal}
                          onHide={() =>
                            this.setState({
                              showExpiryMedicineModal: false,
                              expiryQuantity: "",
                              expiryDate: "",
                            })
                          }
                          bsSize="lg"
                        >
                          <Modal.Header>
                            <Modal.Title>Add Expiry Medicine</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Row>
                              <>
                                <Col sm={12}>
                                  <FormGroup>
                                    <ControlLabel>Medicine name</ControlLabel>
                                    <FormControl
                                      disabled
                                      name="medicineName"
                                      value={
                                        this.state.MedicationData &&
                                        this.state.MedicationData.title
                                      }
                                      placeholder="Select Medicine"
                                      type="text"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col sm={12}>
                                  <FormGroup>
                                    <ControlLabel>Expiry Date</ControlLabel>
                                    <div>
                                      <Datetime
                                        timeFormat={false}
                                        dateFormat="YYYY-MM-DD"
                                        inputProps={{
                                          placeholder: "Expiry Date",
                                        }}
                                        // defaultValue={new Date()}
                                        closeOnSelect={true}
                                        onChange={(date) =>
                                          this.setState({
                                            expiryDate:
                                              moment(date).format("YYYY-MM-DD"),
                                          })
                                        }
                                        isValidDate={this.disablePastDt}
                                      />
                                    </div>
                                    {this.state.expryDateError}
                                  </FormGroup>
                                </Col>
                                <Col sm={6}>
                                  <FormGroup>
                                    <ControlLabel>
                                      Medicine Quantity
                                    </ControlLabel>
                                    <FormControl
                                      name="expiryQuantity"
                                      value={this.state.expiryQuantity}
                                      placeholder="Enter Quantity"
                                      onChange={(e) =>
                                        this.handleAvailablrOnChange(e)
                                      }
                                      type="number"
                                    />
                                    {this.state.quantityError}
                                  </FormGroup>
                                </Col>
                                <Col sm={2}>
                                  <FormGroup>
                                    <ControlLabel>
                                      Available Quantity
                                    </ControlLabel>
                                    <FormControl
                                      disabled
                                      name="availablrQuantity"
                                      value={this.state.availableQuantity}
                                      type="text"
                                    />
                                  </FormGroup>
                                </Col>
                              </>
                            </Row>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={() => this.handleExpiryModalSubmit()}
                            >
                              Submit
                            </Button>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={() => this.handleModalClose()}
                            >
                              Cancel
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <Modal
                          show={this.state.out_of_stock_Modal}
                          onHide={() =>
                            this.setState({ out_of_stock_Modal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Mark Out Of Stock</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>
                              Do you want to mark this medication out of stock
                              ?{" "}
                            </p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.close_out_of_stock_Modal.bind(this)}
                            >
                              No
                            </Button>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={this.outofstock.bind(this)}
                            >
                              Yes
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <Modal
                          show={this.state.re_stock_model}
                          onHide={() => this.setState({ re_stock_model: true })}
                        >
                          <Modal.Header>
                            <Modal.Title>Mark Out Restock</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>Do you want to mark this medication restock ?</p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.close_re_stock_Modal.bind(this)}
                            >
                              No
                            </Button>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={this.restock.bind(this)}
                            >
                              Yes
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Grid>
          <Modal
            show={this.state.showAllocatedValue}
            onHide={() => this.setState({ showAllocatedValue: false })}
            bsSize="lg"
          >
            <Modal.Header>
              <Modal.Title>Show Allocated Orders</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: "scroll", height: "70vh" }}>
              <Table>
                <thead>
                  <th>Order Id</th>
                  <th>Quantity</th>
                  <th>Created_at</th>
                </thead>
                <tbody>
                  {this.state.allocatedData.length == 0 ? (
                    <td colspan="10" style={{ textAlign: "center" }}>
                      <h5>No Data Found</h5>{" "}
                    </td>
                  ) : (
                    this.state.allocatedData.map((item) => (
                      <tr>
                        <td>{item.order_id}</td>
                        <td>{item.quantity}</td>
                        <td>{item.created_at}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => this.setState({ showAllocatedValue: false })}
                bsStyle="info"
                fill
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        {this.state.showRefillRequestModal && (
          <RefillOrderModal
            show={this.state.showRefillRequestModal}
            handleClose={() => {
              this.setState({
                showRefillRequestModal: false,
                refillRemarksError: null,
                refillQuantityError: null,
                refillQuantityInput: "",
                refillRemarksInput: "",
              });
            }}
            handleRefillQuantityChange={this.handleRefillQuantityChange}
            handleRefillRequestSubmit={this.handleRefillRequestSubmit}
            refillQuantity={this.state.refillQuantityInput}
            refillRemarks={this.state.refillRemarksInput}
            handleRefillRemarksChange={this.handleRefillRemarksChange}
            refillQuantityError={this.state.refillQuantityError}
            refillRemarksError={this.state.refillRemarksError}
            medicineName={
              this.state.selectedMedicationId &&
              this.state.selectedMedicationId.title
            }
            medicineCode={
              this.state.selectedMedicationId &&
              this.state.selectedMedicationId.item_code
            }
            isSubmitting={this.state.isRefillSubmitting}
          />
        )}
      </>
    );
  }
}

export default withRouter(viewMedication);
